export interface GalleryItem {
  src: string
  alt: string
  caption: string
}

export const gallery: GalleryItem[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/hT98F5GRx6mnzwzHowbWZ7/image.png',
    alt: 'Altar del templo con imágenes religiosas y velas encendidas',
    caption: 'Nuestro altar principal',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/sR1SG7VKAzbFpbL9k7ycso/image.png',
    alt: 'Mesa ritual con velas, cristal en forma de flor y elementos ceremoniales',
    caption: 'Elementos utilizados en las prácticas',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/8w6zTeZaKcXdMGAhhy9oW4/image.png',
    alt: 'Imagen del Arcángel San Miguel rodeada de velas encendidas',
    caption: 'Espacio de oración y recogimiento',
  },
]

export const expertsGallery: GalleryItem[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/jEzWQ6MZdAAQtAn2fYRsne/image.png',
    alt: 'Altar tradicional con imágenes ceremoniales y velas encendidas',
    caption: 'Altar de trabajos tradicionales',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/9W8E3F4UxxgKeyPoau1VTy/image.png',
    alt: 'Segundo altar ceremonial con velas de distintos colores',
    caption: 'Rituales de tradición ancestral',
  },
]
